<template>
  <div>
    <div
      class="general-situation"
      v-for="(item, index) in landListData"
      :key="index"
    >
      <div class="general-situation-content">
        <div class="general-situation-img">
          <el-carousel
            v-if="item.imgUrl && item.imgUrl.length"
            height="160px"
            class="keynote-content-img"
          >
            <el-carousel-item v-for="(item, index) in item.imgUrl" :key="index">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="imgUrl + item.filePath"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="general-situation-main">
          <div class="general-situation-title">{{ item.countyName }}</div>
          <div class="keynote-main">
            {{ item.synopsis }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "generalSituation",
  props: ["landList"],
  data() {
    return {
      landListData: [],
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  watch: {
    landList: {
      handler(newVal) {
        if (!!newVal) {
          this.landListData = newVal;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    setImgUrl(imgUrl) {
      if (!!imgUrl) {
        return imgUrl[0].url;
      }
    },
  },
};
</script>

<style scoped>
.general-situation {
  width: 60%;
  margin: 80px auto auto;
}
.general-situation-content {
  display: flex;
  align-items: center;
}
.general-situation-img {
  width: calc(100% / 3);
  height: 160px;
  margin-right: 20px;
  /*background-image: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  /* background-image: url("~@/assets/promotion/quj.png");
  background-size: 100% 100%; */
}
.keynote-main {
  margin: 0;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.general-situation-main {
  flex: 1;
  height: 160px;
}
.general-situation-title {
  font-size: 20px;
  font-weight: bold;
  color: #0b34b7;
  margin-bottom: 10px;
  display: block;
}
</style>